// WCAG relative-luminance coefficients (sRGB) and the AA contrast threshold
// for small bold text.
const R_COEFFICIENT = 0.2126;
const G_COEFFICIENT = 0.7152;
const B_COEFFICIENT = 0.0722;
const GAMMA_THRESHOLD = 0.03928;
const GAMMA_OFFSET = 0.055;
const GAMMA_EXPONENT = 2.4;
const WHITE_CONTRAST_THRESHOLD = 4.5;

const linearize = (channel: number): number => {
    const c = channel / 255;
    return c <= GAMMA_THRESHOLD
        ? c / 12.92
        : ((c + GAMMA_OFFSET) / (1 + GAMMA_OFFSET)) ** GAMMA_EXPONENT;
};

const relativeLuminance = (hex: string): number => {
    const value = hex.replace('#', '');
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return (
        R_COEFFICIENT * linearize(r) +
        G_COEFFICIENT * linearize(g) +
        B_COEFFICIENT * linearize(b)
    );
};

/**
 * Picks a readable label colour for text drawn on a solid fill: `'light'`
 * (white text) once the fill is dark enough for a 4.5:1 contrast ratio
 * against white, `'dark'` otherwise.
 */
export const labelColorOn = (fillHex: string): 'light' | 'dark' => {
    const contrastAgainstWhite = 1.05 / (relativeLuminance(fillHex) + 0.05);
    return contrastAgainstWhite >= WHITE_CONTRAST_THRESHOLD ? 'light' : 'dark';
};
